export default __webpack_public_path__ + "static/media/Path3407.1d3088cb.svg";